import { FormInstance } from "antd/es/form";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMasrafRaporu_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMasrafRaporu_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  MasrafCesidiCombo: any[];
  MasrafCesidiCombo_dummy: any[];
  SirketCombo: any[];
  SirketCombo_dummy: any[];
  AddMonths: Date;
  AddMonths_dummy: Date;
  SetValueOf: any;
  SetValueOf_dummy: any;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  SirketSelectAll: any[];
  SirketSelectAll_dummy: any[];
  MasrafRaporu: any[];
  MasrafRaporu_dummy: any[];
  isComp385716Visible: "visible" | "hidden";
}

export class MasrafRaporu_ScreenBase extends React.PureComponent<
  IMasrafRaporu_ScreenProps,
  any
> {
  masrafraporu_255972_value_kuikaSelectBoxRef: React.RefObject<any>;
  masrafraporu_530443_value_kuikaSelectBoxRef: React.RefObject<any>;
  masrafraporu_399769_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "f828031c-1cd0-4632-bfcd-dd8a26aa37ec",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 923160, PropertyName: "value", Value: "Masraf Raporu" },
        { Id: 385716, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 46824, PropertyName: "value", Value: "Şirket" },
        { Id: 255972, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 987692, PropertyName: "value", Value: "Masraf Tipi" },
        { Id: 530443, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 848050, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 191557,
          PropertyName: "startDatePlaceholder",
          Value: "Başlangıç",
        },
        { Id: 191557, PropertyName: "endDatePlaceholder", Value: "Bitiş" },
        { Id: 135352, PropertyName: "label", Value: "Listele" },
        {
          Id: 399769,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 6872087, PropertyName: "title", Value: "Rezervasyon No" },
        {
          Id: 6476116,
          PropertyName: "value",
          Value: "[datafield:rezervasyonno]",
        },
        { Id: 691861, PropertyName: "title", Value: "Uçuş No" },
        { Id: 578519, PropertyName: "value", Value: "[datafield:ucusno]" },
        { Id: 751858, PropertyName: "placeholder", Value: "15" },
        { Id: 7559311, PropertyName: "title", Value: "Uçuş Tarihi" },
        { Id: 3046555, PropertyName: "value", Value: "[datafield:ucustarihi]" },
        { Id: 9350491, PropertyName: "title", Value: "Kalkış Nokta" },
        {
          Id: 7317383,
          PropertyName: "value",
          Value: "[datafield:kalkisnokta]",
        },
        { Id: 5492710, PropertyName: "title", Value: "Varış Nokta" },
        { Id: 9067523, PropertyName: "value", Value: "[datafield:varisnokta]" },
        { Id: 648961, PropertyName: "title", Value: "Masraf Sıra No" },
        { Id: 319008, PropertyName: "value", Value: "[datafield:sirano]" },
        { Id: 212572, PropertyName: "placeholder", Value: "15" },
        { Id: 976551, PropertyName: "title", Value: "Masraf Kodu" },
        { Id: 37285, PropertyName: "value", Value: "[datafield:masrafkodu]" },
        { Id: 764525, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 239391, PropertyName: "title", Value: "Masraf Çeşidi" },
        {
          Id: 979828,
          PropertyName: "value",
          Value: "[datafield:masrafcesidi]",
        },
        { Id: 223037, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 140992, PropertyName: "title", Value: "Şirketler" },
        { Id: 739633, PropertyName: "value", Value: "[datafield:sirketler]" },
        { Id: 379886, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 775210, PropertyName: "title", Value: "Tutar" },
        { Id: 399316, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 210640, PropertyName: "placeholder", Value: "15" },
        { Id: 49165, PropertyName: "title", Value: "P.Br." },
        { Id: 141350, PropertyName: "value", Value: "[datafield:pbr]" },
        { Id: 388413, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 220797, PropertyName: "title", Value: "Şirket" },
        { Id: 544641, PropertyName: "value", Value: "[datafield:sirket]" },
        { Id: 151718, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 202920, PropertyName: "title", Value: "Şirket Tutar" },
        { Id: 385138, PropertyName: "value", Value: "[datafield:sirkettutar]" },
        { Id: 797237, PropertyName: "placeholder", Value: "15" },
        { Id: 959082, PropertyName: "title", Value: "P.Br." },
        { Id: 992708, PropertyName: "value", Value: "[datafield:pbr2]" },
        { Id: 689976, PropertyName: "placeholder", Value: "Type here..." },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.masrafraporu_385716_value_kuikaTextInputRef = React.createRef();
    this.masrafraporu_255972_value_kuikaSelectBoxRef = React.createRef();
    this.masrafraporu_530443_value_kuikaSelectBoxRef = React.createRef();
    this.masrafraporu_399769_value_kuikaTableRef = React.createRef();
    this.masrafraporu_764525_value_kuikaTextInputRef = React.createRef();
    this.masrafraporu_223037_value_kuikaTextInputRef = React.createRef();
    this.masrafraporu_379886_value_kuikaTextInputRef = React.createRef();
    this.masrafraporu_388413_value_kuikaTextInputRef = React.createRef();
    this.masrafraporu_151718_value_kuikaTextInputRef = React.createRef();
    this.masrafraporu_689976_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      MasrafCesidiCombo: [],
      SirketCombo: [],
      AddMonths: "",
      SetValueOf: "",
      TriggerEvent: "",
      SirketSelectAll: [],
      MasrafRaporu: [],
      isComp385716Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("masrafraporu", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MasrafRaporuPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("masrafraporu", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "FLYASISTAN",
      "FLYMALIISLER",
      "FLYADMIN",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("masrafraporu", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MasrafRaporuPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MasrafRaporuPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      date_2: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      months_2: ReactSystemFunctions.convertToTypeByName(-3, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafRaporu/MasrafRaporuPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.MasrafCesidiCombo = result?.data.masrafCesidiCombo;

    formVars.masrafraporu_530443_options = stateVars.MasrafCesidiCombo;
    stateVars.SirketCombo = result?.data.sirketCombo;

    formVars.masrafraporu_255972_options = stateVars.SirketCombo;
    stateVars.AddMonths = result?.data.addMonths;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafRaporuPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafRaporuPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masrafraporu_191557_value",
        "string"
      ),
      ReactSystemFunctions.value(this, this.state.AddMonths),
      ReactSystemFunctions.convertToTypeByName("startValue", "string"),
      false
    );
    if (await this.MasrafRaporuComponent_135352_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafRaporuPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MasrafRaporuPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafRaporu/MasrafRaporuPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SirketSelectAll = result?.data.sirketSelectAll;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafRaporuPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafRaporuPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_255972 =
      stateVars.SirketCombo ?? this.state.SirketCombo;
    stateVars.dataSource_255972 =
      stateVars.SirketCombo ?? this.state.SirketCombo;

    stateVars.dataSource_530443 =
      stateVars.MasrafCesidiCombo ?? this.state.MasrafCesidiCombo;
    stateVars.dataSource_530443 =
      stateVars.MasrafCesidiCombo ?? this.state.MasrafCesidiCombo;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MasrafRaporuComponent_981633_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MasrafRaporu",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "139195",
      null,
      "left",
      "true",
      "450px",
      "",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafRaporuComponent_135352_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafraporu_191557_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafraporu_191557_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      MasrafKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafraporu_530443_value",
            "value",
            "MasrafCesidiCombo",
            "kod",
            "kod"
          )
        ),
        "string"
      ),
      Sirket_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafraporu_255972_value",
            "value",
            "SirketCombo",
            "filtre",
            "filtre"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafRaporu/MasrafRaporuComponent_135352_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.MasrafRaporu = result?.data.masrafRaporu;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafRaporuComponent_135352_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafRaporuComponent_135352_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_399769 =
      stateVars.MasrafRaporu ?? this.state.MasrafRaporu;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MasrafRaporuPageInit();
    }
  }
}
